import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment"
import _ from "lodash";
import { Toast } from 'primereact/toast';
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import { Sidebar } from "primereact/sidebar";
import { OverlayPanel } from 'primereact/overlaypanel';

import { Table } from "../../helpers"
import { Button } from "../../helpers";

import Loading from "../../common/Loading";
import ButtonGroup from "../../common/ButtonGroup";

import PIWiseInvoiceSearch from './Components/PIWiseInvoiceSearch'
import SellerPOAndPISplitView from "./Components/SellerPOAndPISplitView";
import PaymentHistory from "../VendorPaymentSummary/components/PaymentHistory";
import RaiseTicketModal from "./Components/RaiseTicketModal";
import QueuedTimer from "./Components/QueuedTimer";
import PIQueue from "./Components/PIQueue";
import ManualAssignDialog from "./Components/ManualAssignDialog";

import RaiseImg from "../../images/click.jpg"
import greyClockImg from "../../images/greyClock.png"
import checkInCircleImg from "../../images/check-circle.png"
import WorkInProgressImg from "../../images/work-in-progress.png";
import refreshImg from "../../images/refresh.jpg"

import "./index.css"

import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import { checkPermissions, getDateString, isMobile, numberConversion } from "../../utils";

import { getPendingProcessLineItems } from "../../services/api/processLineItems";
import { fetchInvoiceVerificationData, updateSearchParams, setIsSearchVisible } from "../../services/redux/reducers/invoiceVerification/invoiceVerification";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchCompanyCreditPeriods, fetchHSNMasterData, fetchStates, fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getExpenseCategories } from "../../services/api/expenseCategories";
import { fetchProcessLineStatus } from "../../services/redux/reducers/processLineStatus/processLineStatus";
import { fetchPendingProcessLineItems, updatePendingProcessLineItems } from "../../services/redux/reducers/processLineItems/processLineItems";
import { getProcessLineStatusByUserId } from "../../services/api/processLineStatus";
import { assignNextProcessLineItem } from "../../services/api/processLineItems";

import SmartFilterActiveImg from "../../images/smartFilterActiveImg_.png"
import { getProcessLines } from "../../services/api/processLines";
import { DATE_TIME_FORMAT } from "../../constants";
import { useSearchPin } from "../../hooks/useSearchPin";


const PIWiseInvoiceVerification = () => {
    const dispatch = useDispatch()
    const { isSearchPinned, toggleSearchPin, setSearchPin } = useSearchPin()
    
    const [isLoading, setIsLoading] = useState(false)
    let [selectedInvoice, setSelectedInvoice] = useState({})
    const [displayedVendorPayments, setDisplayedVendorPayments] = useState([])
    const [expenseCategories, setExpenseCategories] = useState([])

    const [visiblePIAndSellerPOSplitView, setVisiblePIAndSellerPOSplitView] = useState(false)
    const [isVendorPaymentHistoryVisible, setIsVendorPaymentHistoryVisible] = useState(false)
    const [isRaiseTicketVisible, setIsRaiseTicketVisible] = useState(false)
    const [selectedRow, setSelectedRow] = useState({})
    const [visiblePIQueue, setVisiblePIQueue] = useState(false)
    const [sellerPIProcessLine, setSellerPIProcessLine] = useState({})
    const [globalElapsedTime, setGlobalElapsedTime] = useState(0)
    const [isHoveringSearchZone, setIsHoveringSearchZone] = useState(false)
    const [hasEverHoveredRightEdge, setHasEverHoveredRightEdge] = useState(false)

    let sellerPIPunch = useSelector(state => state.invoiceVerification.invoiceVerificationData)
    const vendorPayments = useSelector(state => state.invoiceVerification.vendorPayments)
    const usersData = useSelector(state => state.userDetails)
    const isTableLoading = useSelector(state => state.invoiceVerification.loading)
    const paginationParams = useSelector(state => state.invoiceVerification.paginationParams)
    const searchParams = useSelector(state => state.invoiceVerification.searchParams)
    const statusList = useSelector((state) => state.common.status)
    const isSearchVisible = useSelector(state => state.invoiceVerification.isSearchVisible)

    const pendingProcessLineItems = useSelector(state => state.processLineItems.pendingProcessLineItems)

    const priorityQueue = pendingProcessLineItems.filter(eachItem => eachItem.sellerPIPunchPriority === 1)
    const regularQueue = pendingProcessLineItems.filter(eachItem => eachItem.sellerPIPunchPriority !== 1)

    const priorityQueueItemCount = priorityQueue.reduce((sum, item) => sum + parseInt(item.totalPIPunchItems || 0), 0)
    const regularQueueItemCount = regularQueue.reduce((sum, item) => sum + parseInt(item.totalPIPunchItems || 0), 0)

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const assignNextOverlayRef = useRef(null)
    const manualAssignOverlayRef = useRef(null)

    const isMobileDevice = isMobile()

    useEffect(() => {
        dispatch(fetchHSNMasterData())
        dispatch(fetchStates())
        dispatch(fetchStatus())
        dispatch(fetchCompanyCreditPeriods())
        dispatch(fetchProcessLineStatus())
        dispatch(fetchPendingProcessLineItems())
        fetchExpenseCategories()
        getProcessLinesData()

        const currentDate = new Date()
        let fromDate = new Date()
        fromDate.setDate(currentDate.getDate() - 15)

        fromDate = new Date(fromDate)
        let toDate = new Date()

        const updatedSearchParams = {
            ...searchParams,
            fromDate,
            toDate,
            userId: usersData.userId,
            smartSearch: true
        }
        dispatch(fetchInvoiceVerificationData({ ...paginationParams, ...updatedSearchParams }))
        dispatch(updateSearchParams(updatedSearchParams))

    }, [])

    useEffect(() => {
        if (!isSearchPinned && !isHoveringSearchZone) {
            dispatch(setIsSearchVisible(false))
        }

        const handleMouseMove = (e) => {
            if (isSearchPinned) return

            const panelWidth = window.innerWidth * 0.18
            const buffer = 8
            const screenRightEdge = window.innerWidth
            const activeZoneLeft = screenRightEdge - (panelWidth + buffer)

            if (e.clientX < activeZoneLeft) {
                setIsHoveringSearchZone(false)
                setHasEverHoveredRightEdge(false)
            } else {
                setIsHoveringSearchZone(true)
            }
        }

        if (!isSearchPinned && (isHoveringSearchZone || hasEverHoveredRightEdge)) {
            window.addEventListener('mousemove', handleMouseMove)
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove)
        }
    }, [isSearchPinned, isHoveringSearchZone, hasEverHoveredRightEdge])

    const getProcessLinesData = async () => {
        const processLineRes = await getProcessLines()
        if (processLineRes.failure){
            dispatch(raiseToast({severity:'error', summary: 'Process Lines', detail: processLineRes.data.error}))
        }

        const relatedSellerPIProcessLine = processLineRes.data.find(eachProcessLine => eachProcessLine.processLineId === 1)
        setSellerPIProcessLine(relatedSellerPIProcessLine)
    }

    const fetchExpenseCategories = async () => {
        const response = await getExpenseCategories()
        if (response?.failure) {
            dispatch(raiseToast({ severity: 'error', summary: 'Expense Categories', detail: response.data.error, life: 3000 }))
        }

        let sortedExpenseCategories = _.sortBy(response.data, "expenseCategoryName")
        setExpenseCategories(sortedExpenseCategories)
    }

    const handleCopyClick = (docNo) => {
        if (docNo) {
            navigator.clipboard.writeText(docNo)
                .then(() => {
                    return dispatch(raiseToast({ severity: 'success', detail: "Copied!", life: 3000 }))
                })
                .catch((error) => {
                    return dispatch(raiseToast({ severity: 'error', detail: "Can't copy", life: 3000 }))
                })
        }
    }

    const getPurchaseInvoiceBody = (row) => {
        return (
            <div className="">
                <div style={{ textDecoration: row?.sellerPOStatus === 6 ? 'line-through' : 'none' }}> <span style={{ fontSize: "12px" }}></span> {row?.PIDocNo}</div>
                <div className="flex justify-content-center align-items-center" style={{ fontWeight: "bold", fontSize: "13px" }}>
                    <span style={{ fontSize: "12px", wordBreak: "keep-all", textDecoration: row?.sellerPOStatus === 6 ? 'line-through' : 'none' }}>{row?.sellerPINumber ? " " + row?.sellerPINumber : "-"}</span><i className="pi pi-eye cursor-pointer ml-1 compare-tooltip" onClick={() => { setVisiblePIAndSellerPOSplitView(true); setSelectedInvoice(row) }} />
                </div>
                <Tooltip target={`.compare-tooltip`} showDelay={1000} hideDelay={300} position="top">
                    <p>Click here to view both seller PO and seller PI</p>
                </Tooltip>
            </div>
        )
    }

    const getCompanyBody = (row) => {
        return (
            <div className="">
                <div style={{ textDecoration: row?.sellerPOStatus === 6 ? 'line-through' : 'none' }}>{row["companyName"]}</div>
            </div>
        )
    }

    const getKAMBody = (row) => {
        return (
            <div className="">
                <div style={{ textDecoration: row?.sellerPOStatus === 6 ? 'line-through' : 'none' }}>{row["firstName"] + " " + row["lastName"]}</div>
            </div>
        )
    }

    const getSellerPIDateBody = (row) => {
        let dateString = getDateString(row.sellerPIDate)
        return (
            <div className="">
                <div style={{ textDecoration: row.sellerPOStatus === 6 ? 'line-through' : 'none' }}>{row?.sellerPIDate ? dateString : "-"}</div>
            </div>
        )
    }

    const getTotalAmountBody = (row) => {
        return (
            <div className="text-center">
                <div style={{ textDecoration: row.sellerPOStatus === 6 ? 'line-through' : 'none' }}>{numberConversion(row?.sellerPITotalAmount, numberLocale)}</div>
            </div>
        )
    }

    const getSellerPIUploadedDateBody = (row) => {
        let dateString = getDateString(row.sellerPIUploadedDate)
        return (
            <div className="text-center">
                <div style={{ textDecoration: row.sellerPOStatus === 6 ? 'line-through' : 'none' }}>{row.sellerPIUploadedDate ? dateString : "-"}</div>
            </div>
        )
    }

    const getVPHistoryBody = (row) => {
        const relatedVendorPayments = vendorPayments.filter(eachVendorPayment => eachVendorPayment.sellerPOId === row.sellerPOId)

        const handleViewVendorPayments = () => {
            setIsVendorPaymentHistoryVisible(true)
            setDisplayedVendorPayments(relatedVendorPayments)
        }

        return (
            <div>
                <a style={{ cursor: "pointer", textDecoration: row.sellerPOStatus === 6 ? 'line-through' : 'underline' }} onClick={() => handleViewVendorPayments()} > View </a>
            </div>
        )
    }

    const getStatusBody = (row) => {
        if (row.sellerPOStatus === 6) {
            return (
                <div style={{ textDecoration: row.sellerPOStatus === 6 ? 'line-through' : 'none' }}>
                    Seller PO Cancelled
                </div>
            )
        } else if (row.buyerPOStatus === 4 || row.buyerPOStatus === 6) {
            return (
                <div>
                    Buyer PO FC/ Cancelled
                </div>
            )
        }
    }

    const handleRaiseTicket = (row) => {
        setSelectedRow(row)
        setIsRaiseTicketVisible(true)
    }

    const raiseIssueBody = (row) => {
        const {isPermitted} = checkPermissions({ ...usersData, permissions: [170] })
        
        let relatedTicket = null
        if (row.tickets && row.tickets.length > 0) {
            relatedTicket = row.tickets[0]
        }

        return (
            <div>
                {relatedTicket ? 
                    ([1, 9, 10].includes(relatedTicket["ticketStatusId"])) ? 
                        <a style={{ cursor: "pointer", fontSize: "20px", color: "grey" }} onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')} title={'In Progress'}>
                            <img src={WorkInProgressImg} style={{ height: 23 }} />
                        </a>
                        :
                        relatedTicket["ticketStatusId"] === 8 ? 
                            <a
                                style={{ cursor: "pointer", fontSize: "20px", color: "orange" }}
                                onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')}
                                title={'Pending Closure'}
                            > <img src={greyClockImg} style={{ height: 24 }} /></a>
                            : 
                            <a style={{ cursor: "pointer", fontSize: "20px", color: "darkgreen" }} onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')} title={'Resolved'}>
                                <img src={checkInCircleImg} style={{ height: 30 }} />
                            </a>
                    :
                    <>
                        <i style={{ cursor: isPermitted ? "pointer" : "not-allowed", fontSize: "20px", color: "red" }}
                            className={`${!isPermitted ? 'disabled-icon' : 'cursor-pointer'} custom-raise-tooltip`}
                            onClick={isPermitted ? () => handleRaiseTicket(row) : null}
                        >
                            <img src={RaiseImg} style={{ height: 26 }} />
                        </i>
                        {
                            !isPermitted && (
                                <Tooltip target={`.custom-raise-tooltip`} position="top" autoHide>
                                    Access restricted: Only Finance team can raise issues.
                                </Tooltip>
                            )
                        }
                    </>
                }
            </div>
        )
    }

    const getTDSStatusBody = (row) => {
        if (row.tdsAmount) {
            return <span style={{ fontSize: "12px", textDecoration: row?.sellerPOStatus === 6 ? 'line-through' : 'none' }}>INCLUDED</span>
        } else {
            return <span style={{ fontSize: "12px", textDecoration: row?.sellerPOStatus === 6 ? 'line-through' : 'none' }}>NOT INCLUDED</span>
        }
    }

    const getSellerPODocNo = (row) => {
        const date = moment(row?.sellerPOCreatedDate).format(DATE_TIME_FORMAT)
        return (
            <div className='req-no-container' style={{ position: "relative" }}>
                {
                    row.expenseCategoryId ? <><span style={{ fontSize: "12px", fontWeight: "bold" }}>EXPENSE</span><br /></> : null
                }
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        row?.sellerPODocNo ?
                            <>
                                <p className='doc-no' style={{ cursor: "pointer", textDecoration: row?.sellerPOStatus === 6 ? 'line-through' : 'none' }} onClick={() => window.open(`/sellerpo/${row?.sellerPOId}`, "_blank")} >{row?.sellerPODocNo}</p>
                                {row.mongoSellerPOId ? <i className="pi pi-external-link pl-1 doc-copy-icon" onClick={() => window.open(`https://app.procmart.com/admin/sellerpo/${row.mongoSellerPOId}`, "_blank")} ></i> : null}
                                <i className="pi pi-copy pl-1 doc-copy-icon" onClick={() => handleCopyClick(row?.sellerPODocNo)} ></i>
                            </>
                            : ""
                    }
                </div>
                <p className='date'>{date}</p>
            </div>
        )
    }

    const handleSmartFilter = async () => {
        let updatedVerificationParams = {
            ...paginationParams,
            ...searchParams,
            smartSearch: true,
        }
        dispatch(fetchInvoiceVerificationData(updatedVerificationParams))
        dispatch(updateSearchParams({ ...searchParams, smartSearch: true }))
        dispatch(fetchPendingProcessLineItems())
    }

    const smartFilterBody = () => {
        return (
            <img src={SmartFilterActiveImg} style={{ width: "25px", cursor: 'pointer', backgroundImage: 'radial-gradient(circle at top left, #cad4ff 2%, #ffffff00)' }} onClick={() => handleSmartFilter()} />
        )
    }

    const queuedTimerBody = (row) => {
        if (!row.relatedPLItemCreatedAt || [1, 9, 10].includes(row.tickets?.[0].ticketStatusId)) {
            return <div> - </div>
        }
        const relatedPLItemCreatedAt = moment(row.relatedPLItemCreatedAt).format("DD.MM.YYYY HH:mm")

        return (
            <>
                <span className={`custom-tooltip-${row.sellerPIPunchId}`}>
                    <QueuedTimer createdAt={relatedPLItemCreatedAt} docLinkId={row.sellerPIPunchId} />
                </span>
            </>
        )
    }

    const hideManualAssignPanel = () =>{ 
        if (manualAssignOverlayRef.current) {
            manualAssignOverlayRef.current.hide()
        }
    }

    const handleManualAssign = (e) => {
        setTimeout(() => {
            if (manualAssignOverlayRef.current) {
                manualAssignOverlayRef.current.show(e)
            }
        }, 0)
    }


    const getAssigneeBody = (row) => {
        if (!row.relatedPLItemAssigneeId) {
            return <div> <Button style={{ height: "25px" }} onClick={(e) => { setSelectedInvoice(row); handleManualAssign(e)}} label='Assign' disabled={!sellerPIProcessLine.lineOwnersList.includes(usersData.userId)}/> </div>
        }
        return <div>{row.processLineAssignee}</div>
    }

    const tableColumns = [
        {
            header: smartFilterBody,
            body: "",
            style: { minWidth: "5px" }
        },
        {
            header: 'Company Name',
            field: '',
            style: { minWidth: "200px" },
            body: getCompanyBody
        },
        {
            header: 'Seller PO No',
            field: '',
            body: getSellerPODocNo,
            style: { minWidth: "130px" }
        },
        {
            header: 'KAM Name',
            field: '',
            body: getKAMBody,
            style: { minWidth: "120px" }
        },
        {
            header: 'Purchase Invoice',
            field: '',
            body: getPurchaseInvoiceBody,
            style: { minWidth: "150px" }
        },
        {
            header: 'PI Date',
            field: '',
            body: getSellerPIDateBody,
            style: { minWidth: "100px" }
        },
        {
            header: 'PI Uploaded Date',
            field: '',
            body: getSellerPIUploadedDateBody,
            style: { minWidth: "120px" },
        },
        {
            header: 'Total Amount',
            field: '',
            body: getTotalAmountBody,
            style: { minWidth: "120px" }
        },
        {
            header: 'VP History',
            field: '',
            body: getVPHistoryBody,
            style: { minWidth: "100px" }
        },
        {
            header: 'TDS Status',
            field: '',
            body: getTDSStatusBody,
            style: { minWidth: "130px" }
        },
        {
            header: 'Remark',
            field: '',
            body: getStatusBody
        },
        {
            header: 'Queued For: HH:MM:SS',
            field: '',
            body: queuedTimerBody,
            style: { minWidth: "130px" }
        },
        {
            header: 'Assignee',
            field: '',
            body: getAssigneeBody
        },
        {
            header: 'Raise Issue',
            field: '',
            body: raiseIssueBody
        },
    ]

    const handlePageChange = async (e) => {
        let paginatorParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        if (searchParams.searchBy && searchParams.searchBy !== "all") {
            paginatorParams[searchParams.searchBy] = searchParams.searchText.trim();
        }
        dispatch(fetchInvoiceVerificationData(paginatorParams))
    }

    const handleCheckInClick = () => {
        assignNextOverlayRef.current.hide()
        window.open('/process-lines', '_blank')
    }

    const handleAssignNext = async (e) => {
        const data = {
            userId: usersData.userId,
            processLineId: 1
        }

        setIsLoading(true)
        const response = await getProcessLineStatusByUserId(data)
        setIsLoading(false)

        if (response.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: "CheckIn Status", detail: response.data.error, life: 3000 }))
        }
        else {
            if (!response.data?.currentStatus) {
                setTimeout(() => {
                    if (assignNextOverlayRef.current) {
                        assignNextOverlayRef.current.show(e)
                    }
                }, 0)
            } else {
                const data = {
                    assigneeId: usersData.userId,
                    updatedBy: usersData.userId,
                    updatedAt: new Date()
                }
                setIsLoading(true)
                const assignNextItem = await assignNextProcessLineItem(data)
                setIsLoading(false)
                if (assignNextItem.failure) {
                    const updatedSearchParams = { ...searchParams, smartSearch: true }
                    dispatch(fetchInvoiceVerificationData({ ...paginationParams, ...updatedSearchParams }))
                    dispatch(fetchPendingProcessLineItems())
                    dispatch(updateSearchParams({ ...searchParams, ...updatedSearchParams }))
                    return dispatch(raiseToast({ severity: 'error', summary: 'Assige Next Item', detail: assignNextItem.data.error, life: 3000 }))
                }
                else {
                    const updatedSearchParams = { ...searchParams, smartSearch: true }
                    dispatch(fetchInvoiceVerificationData({ ...paginationParams, ...updatedSearchParams }))
                    dispatch(fetchPendingProcessLineItems())
                    dispatch(updateSearchParams({ ...searchParams, ...updatedSearchParams }))
                    return dispatch(raiseToast({ severity: 'success', detail: 'PI has been assigned successfully.', life: 3000 }))
                }
            }
        }
    }

    const handleRefreshQueue = async () => {
        setIsLoading(true)
        const response = await getPendingProcessLineItems()
        setIsLoading(false)

        if(response.failure){
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        }
        if(response.data){
            dispatch(updatePendingProcessLineItems(response.data))
        }
    }

    let canAssign = false
    if(sellerPIProcessLine.lineOwnersList?.includes(usersData.userId) || sellerPIProcessLine.usersList?.includes(usersData.userId)){
        canAssign = true
    }

    const relatedSellerPIPunch = sellerPIPunch.find(eachPIPunch => eachPIPunch.sellerPIPunchId === selectedInvoice?.sellerPIPunchId)

    const handleSearchTabDisplay = () => {
        if (!isSearchPinned) {
          dispatch(setIsSearchVisible(!isSearchVisible))
        }
    }
    
    const actionButtons = [
        {
            label: "ASSIGN NEXT",
            command: (e) => handleAssignNext(e),
            disabled: isTableLoading || !canAssign
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            // className: isSearchActive ? "active-group-button" : ""
        },
        {
            icon: isSearchPinned ? "pi pi-lock" : "pi pi-lock-open",
            command: () => toggleSearchPin() 
        }
    ]

    let displaySearchBox = isSearchPinned || isHoveringSearchZone || isSearchVisible

    return (
        <div className="piwise-invoce-booking-layout flex flex-column">
            <Toast ref={Toast} />
            <div
                onMouseEnter={() => {
                    if (!isSearchPinned) {
                        setIsHoveringSearchZone(true)
                        setHasEverHoveredRightEdge(true)
                        dispatch(setIsSearchVisible(true))
                    }
                }}
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '8px',
                    height: '100vh',
                    zIndex: 999
                }}
            />

            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="m-2">PI VERIFICATION</h4>
                <div
                    className="uppercase flex flex-column md:flex-row md:justify-content-between md:align-items-center mb-2 mx-2 p-2 bg-white"
                    style={{
                        borderRadius: '6px',
                        border: '1px solid rgb(247 224 59 / 0%))'
                    }}
                >
                    <span className="mt-1 mb-2 md:mb-0 text-sm font-medium flex-1">Pending PI in the Queue :</span>

                    <div className="flex flex-wrap gap-2 justify-start md:justify-end items-center ml-2 flex-2">
                        <span className="ml-2 px-4 py-1 text-sm font-bold"
                            style={{
                                backgroundColor: '#E7C499',
                                color: '#b66f17',
                                border: '1px solid #EF9A9A',
                                borderRadius: '8px'
                            }}>
                            Priority: {priorityQueue.length}({priorityQueueItemCount})
                        </span>
                        <span className="ml-2 px-4 py-1 text-sm font-bold"
                            style={{
                                backgroundColor: '#BBDEFB',
                                color: '#1976D2',
                                border: '1px solid #90CAF9',
                                borderRadius: '8px'
                            }}>
                            Regular: {regularQueue.length}({regularQueueItemCount})
                        </span>
                        <span className="ml-2 px-4 py-1 text-sm font-bold hover:bg-gray-200 transition"
                            style={{
                                backgroundColor: '#E0F7FA',
                                color: '#00796B',
                                border: '1px solid #4DB6AC',
                                borderRadius: '8px',
                                cursor: 'pointer'
                            }}
                            onClick={() => setVisiblePIQueue(true)}
                        >
                            Open Queue
                        </span>
                        <img
                            src={refreshImg}
                            alt="Refresh"
                            className="ml-2 cursor-pointer"
                            style={{
                                height: 28,
                                objectFit: "contain"
                            }}
                            onClick={() => handleRefreshQueue()}
                        />
                    </div>
                </div>
                 
                <div className="flex gap-2 justify-content-end" style={{ height: "36px"}}>
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className='flex flex-row'>
                <div className="pi-wise-invoice-verification-table" style={{ order: "1", width: displaySearchBox && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0'>
                        <div className="flex-grow-1">
                            <Table
                                lazy
                                page={paginationParams.pageNo}
                                onPageChange={(e) => handlePageChange(e)}
                                tableColumns={tableColumns}
                                data={sellerPIPunch}
                                rows={paginationParams.recordsPerPage}
                                scrollable={"true"}
                                scrollHeight={"550px"}
                                paginator
                                totalRecords={paginationParams.totalRecords}
                                loading={isTableLoading}
                            />
                        </div>
                    </div>
                </div>

                {displaySearchBox && (
                    <div
                        style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end"
                        onMouseLeave={(e) => {
                            const bounds = e.currentTarget.getBoundingClientRect()
                            const leftExit = e.clientX < bounds.left
                            const topExit = e.clientY < bounds.top
                            const bottomExit = e.clientY > bounds.bottom

                            if (!isSearchPinned && (leftExit || topExit || bottomExit)) {
                                setIsHoveringSearchZone(false)
                                setHasEverHoveredRightEdge(false)
                            }
                        }}

                        onMouseEnter={() => {
                            if (!isSearchPinned) {
                                setIsHoveringSearchZone(true)
                            }
                        }}
                    >
                        <PIWiseInvoiceSearch expenseCategories={expenseCategories} />
                    </div>
                )}

                {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <PIWiseInvoiceSearch expenseCategories={expenseCategories} />
                    </div>
                }

                {
                    isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <PIWiseInvoiceSearch expenseCategories={expenseCategories} />
                        </Sidebar>
                    </div>
                }
            </div>

            <Loading visible={isLoading} />

            <Dialog header="Seller PO and PI" visible={visiblePIAndSellerPOSplitView} style={{ width: '98vw', height: '95vh' }} onHide={() => setVisiblePIAndSellerPOSplitView(false)}>
                <>  
                    {
                        relatedSellerPIPunch ? 
                            <SellerPOAndPISplitView setIsLoading={setIsLoading} selectedInvoice={selectedInvoice} sellerPOURL={selectedInvoice?.sellerPODocumentURL} sellerPIDoc={selectedInvoice?.sellerPIDocProof} setVisiblePIAndSellerPOSplitView={setVisiblePIAndSellerPOSplitView} />
                            : null
                    }
                </>
            </Dialog>

            <Dialog header="VENDOR PAYMENT HISTORY" visible={isVendorPaymentHistoryVisible} style={{ width: '75vw', minHeight: '30vh' }} onHide={() => { setIsVendorPaymentHistoryVisible(false); setDisplayedVendorPayments([]) }}>
                <div className="vendor-payment-summary-tab" style={{ width: "100%", paddingLeft: "0%", paddingRight: "0%" }}>
                    <PaymentHistory vendorPayments={displayedVendorPayments} sellerPIPunch={sellerPIPunch} statusList={statusList} viewFlag={true} />
                </div>
            </Dialog>

            <Dialog header="RAISE TICKET" visible={isRaiseTicketVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => { setIsRaiseTicketVisible(false) }}>
                <div style={{ width: "100%", paddingLeft: "0%", paddingRight: "0%" }}>
                    <RaiseTicketModal selectedRow={selectedRow} setIsLoading={setIsLoading} setIsRaiseTicketVisible={setIsRaiseTicketVisible} />
                </div>
            </Dialog>
            <OverlayPanel ref={assignNextOverlayRef} style={{ width: '246px', minHeight: "8px" }} dismissable>
                <>
                    <h4 className="mt-3 ml-2 mb-2" >CHECK-IN</h4>
                    <div className='text-center'>
                        <p> You're not checked-in. Please check-in using the button below.</p>
                        <Button className='mb-2' onClick={handleCheckInClick} label="check-in" />
                    </div>
                </>
            </OverlayPanel>
            <OverlayPanel ref={manualAssignOverlayRef} style={{ width: '246px', minHeight: "8px" }} dismissable>
                <>
                    <h4 className="mt-1 ml-2 mb-2" >MANUAL ASSIGN</h4>
                    <ManualAssignDialog sellerPIProcessLine={sellerPIProcessLine} selectedInvoice={selectedInvoice} hideManualAssignPanel={hideManualAssignPanel} setIsLoading={setIsLoading} sellerPIPunch={sellerPIPunch} />
                </>
            </OverlayPanel>
            <Dialog header="QUEUE OVERVIEW" visible={visiblePIQueue} style={{ width: '75vw', height: '66vh' }} onHide={() => { setVisiblePIQueue(false) }}>
                <PIQueue pendingProcessLineItems={pendingProcessLineItems} handleRefreshQueue={handleRefreshQueue} sellerPIProcessLine={sellerPIProcessLine} setIsLoading={setIsLoading} />
            </Dialog>
        </div>
    )
}

export default PIWiseInvoiceVerification;